import { render } from "./TableauClassementChallenge.vue?vue&type=template&id=20ca5148"
import script from "./TableauClassementChallenge.vue?vue&type=script&lang=js"
export * from "./TableauClassementChallenge.vue?vue&type=script&lang=js"

import "./TableauClassementChallenge.vue?vue&type=style&index=0&id=20ca5148&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__